import { render, staticRenderFns } from "./Gap.vue?vue&type=template&id=bee3992a&scoped=true"
import script from "./Gap.vue?vue&type=script&lang=ts"
export * from "./Gap.vue?vue&type=script&lang=ts"
import style0 from "./Gap.vue?vue&type=style&index=0&id=bee3992a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee3992a",
  null
  
)

export default component.exports